module.exports = __webpack_public_path__ + "static/media/icon-instructions-group.662ec730.svg";